import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMomentumReversalsPeaking = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.0955 11.3159C20.5905 10.876 21.3426 10.8981 21.8108 11.3663L34.4986 24.0542V15.8174C34.4986 15.1267 35.0586 14.5668 35.7493 14.5668C36.4401 14.5668 37 15.1267 37 15.8174V27.0736C37 27.7643 36.4401 28.3242 35.7493 28.3242H24.4932C23.8025 28.3242 23.2425 27.7643 23.2425 27.0736C23.2425 26.3828 23.8025 25.8229 24.4932 25.8229H32.7299L20.8759 13.9689L5.0816 28.0083C4.56534 28.4672 3.77482 28.4207 3.31592 27.9045C2.85703 27.3882 2.90353 26.5977 3.41979 26.1388L20.0955 11.3159Z"
	})
});
export default SvgMomentumReversalsPeaking;
